import React from "react";
import styled from "styled-components";
import Modal from "../../../../../_components/Modal";
import Button from "../../../../../_components/Button";
import Text from "../../../../../_components/Text";
import LoadingInput from "../../../../../_components/LoadingInput";
import { FormControl } from "react-bootstrap"
import DatePicker from "react-datepicker";
import moment from 'moment/moment';

const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    @media(max-width: 700px){
        flex-direction: column;
        justify-content: space-between;
    }
`
const NFE_FILTER_LIMITS = [5, 10, 15, 30, 50, 100, 200, 300, 350]

const defaultData = {
    start_number: '',
    end_number: '',
    series: '',
    status: '',
    start_date: '',
    end_date: '',
    end_count: 15
}
export default props => {
    const [showModal, setShowModal] = React.useState(false)
    const [params, setParams] = React.useState(defaultData)
    const [loading, setLoading] = React.useState(false)

    function closeModal() {
        setShowModal(false)
    }
    function openModal() {
        setShowModal(true)
    }
    function onChange(e) {
        const { name: key, value } = e.target
        setParams({
            ...params,
            [key]: value
        })
    }
    function setStartDate(e) {
        setParams({
            ...params,
            "start_date": e ? moment(e).format('YYYY-MM-DD') : ''
        })
    }
    function setEndDate(e) {
        setParams({
            ...params,
            "end_date": e ? moment(e).format('YYYY-MM-DD') : ''
        })
    }
    function onSearch() {
        closeModal()
        if (props.search) {
            props.search({ ...params })
        }
    }
    return <React.Fragment>
        <Text className="p-0 m-0 pb-1">
            Clique no botão abaixo para filtrar as Notas
        </Text>
        <Button onClick={openModal}>
            Exibir filtros
        </Button>
        <Modal onHide={closeModal} show={showModal} title="Pesquisar NF-e">
            <Container>
                <div >
                    <Text>
                        Numeração
                    </Text>
                    <FormGroup
                        loading={loading}
                        name="start_number"
                        value={params.start_number}
                        label="Número Inicial"
                        onChange={onChange} />
                    <FormGroup
                        loading={loading}
                        name="end_number"
                        value={params.end_number}
                        label="Número Final"
                        onChange={onChange} />
                    <FormGroup
                        name="series"
                        loading={loading}
                        value={params.series}
                        label="Série"
                        onChange={onChange} />
                </div>
                <div >
                    <Text>
                        Situação
                    </Text>
                    <div className="form-group">
                        <div className="form-label">
                            Status da NF-e
                        </div>
                        <FormControl
                            onChange={onChange}
                            name="status"
                            disabled={loading}
                            as="select" >
                            <option
                                value=""
                                selected={params.status === ''} >Todas</option>
                            <option
                                value="1"
                                selected={params.status === 1}>Autorizada</option>
                            <option
                                value="2"
                                selected={params.status === 2}>Cancelada</option>
                            <option
                                value="3"
                                selected={params.status === 3}>Rejeitada</option>
                            <option
                                value="4"
                                selected={params.status === 4}>Inutilizada</option>
                            <option
                                value="5"
                                selected={params.status === 5}>Denegada</option>
                            <option
                                value="6"
                                selected={params.status === 6}>Pendente</option>
                        </FormControl>
                    </div>
                </div>
                <div >
                    <Text>
                        Intervalo de datas
                    </Text>
                    <div className="form-group">
                        <div className="form-label">
                            Data Inicial
                        </div>
                        <DatePicker
                            disabled={loading}
                            locale="pt-bR"
                            name="start_date"
                            onChange={setStartDate}
                            selected={moment(params.start_date || new Date())}
                            className="form-control" />
                    </div>
                    <div className="form-group">
                        <div className="form-label">
                            Data Final
                        </div>
                        <DatePicker
                            locale="pt-bR"
                            disabled={loading}
                            name="end_date"
                            onChange={setEndDate}
                            selected={moment(params.end_date || new Date())}
                            className="form-control" />
                    </div>
                </div>
                <div >
                    <Text>
                        Limite de resultados
                    </Text>
                    <div className="form-group">
                        <div className="form-label">
                            Quantidade de resultados
                        </div>
                        <FormControl
                            disabled={loading}
                            onChange={onChange}
                            name="end_count"
                            as="select" >
                                {
                                    NFE_FILTER_LIMITS.map((value, idx)=>{
                                        return <option value={value} key={`nfe-filtar-ilimit=${value}_${idx}`}>{value}</option>
                                    })
                                }
                        </FormControl>
                    </div>
                </div>
            </Container>
            <hr />
            <div className="d-flex justify-content-end">
                <Button
                    disabled={loading} onClick={onSearch}>
                    Pesquisar
                </Button>
            </div>
        </Modal>
    </React.Fragment>
}

function FormGroup(props) {
    return <div className="form-group">
        <div className="form-label">
            {props.label}
        </div>
        <LoadingInput
            loading={props.loading}
            value={props.value}
            name={props.name}
            onChange={props.onChange} />
    </div>
}


// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/List/Filters/index.jsx